import EventCheckBox from '../EventCheckBox';
import { useForm } from 'react-hook-form';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { EVENT_DETAIL_URL, LOGGING_TYPE } from '@/constants/calendar';
import { makeSearchUrl } from './searchModuleUtils';
import { handleGoogleAnalytics } from '@/utils';

const SearchModule = () => {
  const { register, setValue, handleSubmit, watch } = useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const isDetailPage = window.location.pathname === EVENT_DETAIL_URL;

  const startDate = watch('start');

  const onSubmit = data => {
    const url = makeSearchUrl(data);
    handleGoogleAnalytics({
      eventType: LOGGING_TYPE.eventSearch,
      eventLabel: data.search,
    });
    navigate(url, { replace: true });
  };

  useEffect(() => {
    const q = new URLSearchParams(location.search);
    const value = q.get('q');
    if (value) {
      setValue('search', value);
    }
  }, []);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='flex flex-col gap-4'>
          <section className='w-full h-12 flex items-center gap-4 min-w-0'>
            <input
              type='text'
              placeholder='Search'
              {...register('search')}
              className='w-full pt-2 pb-2 !text-sm md:!text-base font-medium border-0 border-b-2 border-[#001326] outline-none autofill:shadow-[0_0_0_1000px_transparent_inset] autofill:bg-clip-text'
            />
            <div
              onClick={handleSubmit(onSubmit)}
              className='relative top-0 right-0 py-2 px-3 rounded-md flex whitespace-nowrap items-center gap-2 !text-sm md:!text-base font-medium bg-[#001326] text-white cursor-pointer hover:scale-95 md:py-2.5 md:px-3 md:justify-center'
            >
              Search
              <img
                src='/svg/search-yellow.svg'
                className='w-[14px] h-[14px] md:w-[1.3rem] md:h-[1.3rem] flex-shrink-0'
                alt='search'
              />
            </div>
          </section>
          <div className='flex flex-row gap-4 justify-center items-center'>
            <input
              type='date'
              min={new Date().toISOString().split('T')[0]}
              {...register('start')}
              className='w-full md:w-fit pt-2 pb-2 !text-sm md:!text-base font-medium border-0 border-b-2 border-[#001326] outline-none autofill:shadow-[0_0_0_1000px_transparent_inset] autofill:bg-clip-text'
            />
            <span className='!text-sm md:!text-base'>~</span>
            <input
              type='date'
              {...register('end')}
              min={startDate}
              className='w-full md:w-fit pt-2 pb-2 !text-sm md:!text-base font-medium border-0 border-b-2 border-[#001326] outline-none autofill:shadow-[0_0_0_1000px_transparent_inset] autofill:bg-clip-text'
            />
          </div>
        </div>
      </form>
      {!isDetailPage && <EventCheckBox />}
    </>
  );
};

export default SearchModule;
